export default __webpack_public_path__ + "static/PressBrand-dee406e7a97ae11a5b3438177b96d34a.svg";